import {
  ImageOptionalLink,
} from '@rsa-digital/evo-shared-components/commonTypes/links';
import { graphql, useStaticQuery } from 'gatsby';
import { processMandatoryImage } from 'helpers/csTypeProcessors';
import { handleAndTrackLinkClick } from 'helpers/navigation';
import useLivePreviewSetup from 'helpers/useLivePreviewSetup';
import { CsAsset } from 'types/contentStack';
import { GlobalNotificationProps } from './types';

type CsGlobalNotification = {
  locale: string;
  image_link: {
    image: CsAsset;
    url: string;
    screenreader_text: string;
  };
  message: string;
};

type HeaderData = {
  allCsGlobalNotification: { nodes: CsGlobalNotification[] };
};

const headerQuery = graphql`
  query {
    allCsGlobalNotification {
      nodes {
        cslp__meta
        locale
        image_link {
          image {
            ...Asset
          }
          url
          screenreader_text
        }
        message
      }
    }
  }
`;

const processImageLink = (logoData: {
  image: CsAsset;
  screenreader_text: string;
  url: string;
}): ImageOptionalLink => ({
  link: {
    url: logoData.url,
    screenReaderText: logoData.screenreader_text,
    onClick: (e) =>
      handleAndTrackLinkClick(
        logoData.url,
        'globalNotificationImageLink',
        logoData.screenreader_text
      )(e),
  },
  image: processMandatoryImage(logoData.image),
});

const useGlobalNotificationData = (
  locale: string
): GlobalNotificationProps | undefined => {
  const { allCsGlobalNotification } = useStaticQuery<HeaderData>(headerQuery);

  const csGlobalNotification = allCsGlobalNotification.nodes.find(
    (data) => data.locale === locale
  );
  const globalNotificationData = useLivePreviewSetup(csGlobalNotification);
  if (!globalNotificationData) {
    return undefined;
  }

  return {
    imageLink: globalNotificationData.image_link.image
      ? processImageLink(globalNotificationData.image_link)
      : undefined,
    message: globalNotificationData.message,
  };
};

export default useGlobalNotificationData;
